import { useState } from "react";

export const useModal = <T = null>() => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState<T | null>(null);

  const open = (item?: T) => {
    setData(item ?? null);
    setIsOpen(true);
  };

  const close = () => {
    setData(null);
    setIsOpen(false);
  };

  return {
    isOpen,
    data,
    open,
    close,
  };
};
